// extracted by mini-css-extract-plugin
export default {"App":"styles_App__xUt14"};